<template>
  <div class="b-toaster-slot">
    <b-toast
      id="example-toast"
      @hidden="onHideToast(toast.id, $event)"
      @shown="onShown(toast.id, toast.time)"
      :class="getStyle(toast)"
      :title="toast.title"
      static
      no-auto-hide
      v-for="(toast, index) in toastList"
      :key="index"
    >
      <span v-html="toast.message" />
    </b-toast>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

import { toastMapper } from '@/store/modules/toast'

const Mappers = Vue.extend({
  computed: {
    ...toastMapper.mapGetters(['toasts']),
  },
  methods: {
    ...toastMapper.mapActions(['delToast']),
  },
})

@Component
export default class Toaster extends Mappers {
  private onHideToast(id: number, e: any) {
    e.preventDefault()
    setTimeout(() => {
      this.delToast(id)
    }, 0)
  }

  private updateToasts() {
    setTimeout(() => {
      this.$bvToast.show('example-toast')
    }, 0)
  }

  private onShown(id: number, time: number) {
    setTimeout(
      () => {
        this.delToast(id)
      },
      time ? time * 1000 : 5000
    )
  }

  private getStyle(toast: any) {
    if (toast.error) {
      return 'b-toast-error'
    } else if (toast.variant) {
      return `b-toast-${toast.variant}`
    } else {
      return 'b-toast-default'
    }
  }

  private get toastList() {
    this.updateToasts()
    return this.toasts
  }
}
</script>

<style lang="scss">
@import '@/scss/_colors.scss';

#example-toast {
  opacity: 1 !important;
  margin-top: 30px;
  width: 300px;
  word-wrap: break-word;
}
.b-toaster-slot {
  position: fixed;
  right: 5px;
  top: 38px;
  z-index: 2000;
}
.b-toast-error .toast-header {
  background-color: map-get($french-palette, 'red-3');
  color: white;
}
.b-toast-default .toast-header {
  background-color: map-get($french-palette, 'blue-3');
  color: white;
}
</style>
